export const OUTPUTS = {
  // Resource Usage elements
  RESOURCE_USAGE_GRID: 'outputs-resource-usage-grid',
  RESOURCE_USAGE_EDIT_SAVE_BUTTON: 'outputs-resource-usage-edit-save-button',
  RESOURCE_USAGE_EDIT_CANCEL_BUTTON: 'outputs-resource-usage-edit-cancel-button',
  RESOURCE_USAGE_EXPORT_BUTTON: 'outputs-resource-usage-export-button',
  RESOURCE_USAGE_EDIT_SEARCH: 'outputs-resource-usage-edit-search',
  RESOURCE_USAGE_EDIT_SHOW_ALL: 'outputs-resource-usage-edit-show-all',
  RESOURCE_USAGE_EDIT_HIDE_ALL: 'outputs-resource-usage-edit-hide-all',
  RESOURCE_USAGE_EDIT_CHECKBOX: 'outputs-resource-usage-edit-checkbox',
  RESOURCE_USAGE_GRID_CHECKBOX: 'outputs-resource-usage-grid-checkbox',

  // Important Dates elements
  IMPORTANT_DATES_GRID: 'outputs-important-dates-grid',
  IMPORTANT_DATES_ADD_BUTTON: 'outputs-important-dates-add-button',
  IMPORTANT_DATES_DIALOG_CLOSE: 'outputs-important-dates-dialog-close',
  IMPORTANT_DATES_ADD_DIALOG_SEARCH: 'outputs-important-dates-add-dialog-search',
  IMPORTANT_DATES_DIALOG_SEARCH_CLEAR: 'outputs-important-dates-dialog-search-clear',
  IMPORTANT_DATES_SEARCH: 'outputs-important-dates-search',
  IMPORTANT_DATES_SEARCH_CLEAR: 'outputs-important-dates-search-clear',

  // Simulations elements
  SIMULATIONS_SETUP_BUTTON: 'outputs-simulations-setup-button',
  SIMULATIONS_ADD_GROUP_BUTTON: 'outputs-simulations-add-group-button',
  SIMULATIONS_RESET_BUTTON: 'outputs-simulations-reset-button',
  SIMULATIONS_ITERATIONS_INPUT: 'outputs-simulations-iterations-input',
  SIMULATIONS_RUN_BUTTON: 'outputs-simulations-run-button',
  SIMULATIONS_DURATION_TAB: 'outputs-simulations-duration-tab',
  SIMULATIONS_LABOR_TAB: 'outputs-simulations-labor-tab',
  SIMULATIONS_EQUIPMENT_TAB: 'outputs-simulations-equipment-tab',
  SIMULATIONS_STOP_BUTTON: 'outputs-simulations-stop-button',

  // Compare elements
  COMPARE_EXPORT_BUTTON: 'outputs-compare-export-button'
} as const;
